// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"421":"a7696a59","882":"12ce9499"}[chunkId] + ".chunk.css";
};